import React from "react";
import { getLabelForTemplateType } from "../../../../types/templates/template-type.functions";
import { withShowIf } from "../../../with-show-if/with-show-If.component";
import { InfoCardOwnerDetailsProps } from "./info-card-owner-details.props";

export const InfoCardOwnerDetails = withShowIf((props: InfoCardOwnerDetailsProps) => (
  <>
    {`Owner: ${props.owner}`} <br /> {"Template:"} {getLabelForTemplateType(props.resourcetype)}
  </>
));
